__webpack_require__.p = "/newuser/";